module.exports = __webpack_public_path__ + "static/media/hollow_bar_WPC.4b1a83d8.svg";